import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  header: 'Suspendre les nouvelles commandes',
  sections: {
    pause_orders: {
      title: 'Combien de temps serez-vous indisponible ?',
      description: "Nous informerons les clients que vous n'acceptez pas de nouvelles commandes",
    },
    order_methods: {
      title: 'Mes modes de commande',
      description: 'Activez ou désactivez les modes de commande pour vos clients',
    },
    delivery_mode: {
      title: 'Modes de livraison',
      description: 'Basculez entre votre réseau de livreurs et le nôtre',
    },
  },
  form: {
    orders_paused_until: {
      options: {
        '10_min': '10 min',
        '15_min': '15 min',
        '20_min': '20 min',
        '25_min': '25 min',
        '1_hour': '1 heure',
        '2_hours': '2 heures',
        rest_of_day: 'Reste de la journée',
      },
    },
    has_standalone_delivery: {
      label: 'Mes livreurs',
    },
    has_external_delivery: {
      label: 'Réseau de livreurs {{provider}}',
    },
  },
  labels: {
    delivery_orders_off: 'Livraisons désactivées',
    delivery_orders_on: 'Livraisons activées',
  },
  modals: {
    toggle_delivery: {
      [true]: {
        title: 'Voulez-vous vraiment activer les commandes en livraison ?',
        description: '',
      },
      [false]: {
        title: 'Voulez-vous vraiment désactiver les commandes en livraison ?',
        description: '',
      },
    },
    switch_delivery_mode: {
      [DeliveryMode.Internal]: {
        title: 'Voulez-vous vraiment passer à vos livreurs ?',
        description: '',
      },
      [DeliveryMode.External]: {
        title: 'Voulez-vous vraiment passer aux livreurs {{provider}} ?',
        description: '',
      },
    },
  },
  buttons: {
    confirm: 'Confirmer',
    cancel: 'Annuler',
  },
  toasts: {
    failed_to_save_changes: "Impossible d'enregistrer les modifications",
    changes_got_saved: 'Modifications enregistrées',
  },
};
